<loader [loading]="isLoading"></loader>

<div class="section-block">

  <!-- Collapse Header -->
  <div class="section-header" [attr.aria-expanded]="!pmaNotesCollapsed" aria-controls="collapseEvent"
    *ngIf="showBvqNotes && !isLoading" (click)="pmaNotesCollapsed = !pmaNotesCollapsed">
    <fa [name]="pmaNotesCollapsed ? 'fa fa-minus' : 'fa fa-plus'"></fa>
    <div class="text">
      PMA Notes
    </div>
  </div>

  <div class="section-content" [collapse]="!pmaNotesCollapsed">
    <!-- No Notes message -->
    <div *ngIf="notes?.length == 0 && !isLoading" class="top-text">
      <h4 style="margin-bottom: 20px;">Report doesn't have any Notes</h4>
      <button class="btn btn-rbv" (click)="onCreateLink()">Create New Note</button>
    </div>

    <!-- List of Link -->
    <div *ngIf="notes?.length > 0 && !isLoading">
      <report-note *ngFor="let note of notes | orderBy: ['ORDER']; let i = index"
        [note]="note" [reportId]="currentReport.ID" [index] = 'i' [length] ="notes.length"
        (onDeleted)="onNoteDeleted(note)" (onOrderUp)="onOrderUp(note, i)" (onOrderDown)="onOrderDown(note, i)"></report-note>

      <div style="text-align: center;padding: 20px;">
        <button class="btn btn-rbv" (click)="onCreateLink()">Create New Note</button>
      </div>
    </div>
  </div>
</div>

<!-- BVQ Notes -->
<div class="section-block mt-4" *ngIf="showBvqNotes && !isLoading">
  <!-- Collapse Header -->
  <div class="section-header" [attr.aria-expanded]="!bvqNotesCollapsed" aria-controls="collapseEvent"
    (click)="bvqNotesCollapsed = !bvqNotesCollapsed">
    <fa [name]="bvqNotesCollapsed ? 'fa fa-minus' : 'fa fa-plus'"></fa>
    <div class="text">
      BVQ Notes
    </div>
  </div>

  <!-- Body -->
  <div class="section-content" [collapse]="!bvqNotesCollapsed">
    <ng-container *ngFor="let note of bvqNotes;">
      <div class="bvqNote">{{note.NOTE}}</div>
    </ng-container>
  </div>
</div>
